import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Rule } from '@helpers/types/models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RulesService } from '../rules.service';
import { exist } from '@campaign-portal/namespace/common/id';

@Component({
	selector: 'app-rule-delete-dialog',
	templateUrl: './dialog.component.html',
	styleUrl: './dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RulesDeleteDialogComponent {

	private readonly destroyRef = inject(DestroyRef);

	constructor(
		@Inject(DIALOG_DATA) public readonly data: { rule: Rule<exist> },
		public readonly rulesService: RulesService,
		private readonly dialogRef: DialogRef<boolean>
	) {
	}

	confirm(): void {
		this.rulesService.delete({ ruleId: this.data.rule.ruleId })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if ( resp.data.rule_id ) {
					this.dialogRef.close(true);
				}
			});
	}

	close(): void {
		this.dialogRef.close(false);
	}
}
